import React from 'react';
import NavMenu from './NavMenu';
import Slider_Sec from './Slider_Sec';
import Services from './Services';
import AboutUs from './AboutUs';
import GetItInTouch from './GetItInTouch';
import Footer from './Footer';

const Main = () => {
    return (
        <>
            <NavMenu />
            <Slider_Sec />
            <AboutUs />
            <Services />
            <GetItInTouch />
            <Footer />
        </>
    )
}

export default Main